export default "__VITE_ASSET__CfLNicGr__"